import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "rtc_token";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Attach token if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const HTTP_UNAUTHORIZED = 401;

// On 401 from protected routes, clear token (let UI redirect)
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === HTTP_UNAUTHORIZED) {
            const url = err.config?.url || "";
            // only clear for explicit auth probes / admin endpoints
            if (
                url.includes("/auth/me") ||
                url.includes("/admin/") ||
                url.includes("/contact") ||
                url.includes("/referral")
            ) {
                localStorage.removeItem(TOKEN_KEY);
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
